<template>
  <b-form-group
    label="Şube"
    label-for="id_branches"
  >
    <validation-provider
      #default="{ errors }"
      name="Şube"
      rules="required"
    >
      <v-select
        id="id_branches"
        :value="dataItem.id_branches"
        :options="branchOptions"
        label="title"
        :reduce="item => item.id"
        placeholder="Şube seçiniz"
        @input="setBranch"
      />
      <small
        v-if="!branchOptions.length"
        class="text-warning"
      >
        Bu lisans için henüz şube yok. Önce Menu Admin'den şube ekleyin.
      </small>
      <small class="text-danger">{{ errors[0] }}</small>
    </validation-provider>
  </b-form-group>
</template>
<script>
import { BFormGroup } from 'bootstrap-vue'
import { ValidationProvider } from 'vee-validate'
import { mapMutations } from 'vuex'
import vSelect from 'vue-select'

export default {
  name: 'Branches',
  components: {
    ValidationProvider,
    BFormGroup,
    vSelect,
  },
  computed: {
    dataItem() {
      return this.$store.getters['drUsers/dataItem']
    },
    branchOptions() {
      return this.$store.getters['drBranches/dataList'].map(item => ({
        id: parseInt(item.id, 10),
        title: item.title,
      }))
    },
  },
  watch: {
    branchOptions(val) {
      if (val.length === 1 && !this.dataItem.id_branches) {
        this.setBranch(val[0].id)
      }
    },
  },
  created() {
    this.getBranches()
  },
  methods: {
    ...mapMutations('drUsers', ['UPDATE_DATA_ITEM_FIELD']),
    setBranch(value) {
      this.UPDATE_DATA_ITEM_FIELD({
        field: 'id_branches',
        value: value ? parseInt(value, 10) : null,
      })
    },
    getBranches() {
      this.$store.dispatch('drBranches/getDataList', {
        select: [
          'branches.id AS id',
          'branches.title AS title',
        ],
        where: {
          'branches.id_licenses': parseInt(this.$route.params.id, 10),
        },
      })
    },
  },
}
</script>
